module.exports = {"attributes":{"viewBox":"0 0 12 12"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">     <path d=\"M0 0h12v12H0z\"/>     <path fill=\"#FFF\" d=\"M5 5V.7a.8.8 0 0 1 1.5 0V5h4.3a.7.7 0 1 1 0 1.5H6.5v4.3a.7.7 0 1 1-1.5 0V6.5H.7A.8.8 0 0 1 .8 5H5z\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-plus.svg
// module id = 348
// module chunks = 0